import { Check } from "lucide-react";
import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updatePrivacy } from "../../../endpoints/candidate.service";
import { setUserData } from "../../../store/actions/auth.action";
import { PrivacyType } from "../../../utils/types";

const Privacy: React.FC = () => {
  const { user } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();
  const { watch, setValue } = useForm({
    defaultValues: user?.privacySettings,
  });

  const fields = watch();

  const changePrivacy = async (payload) => {
    const key = Object.keys(payload)?.[0];
    try {
      setValue(key, payload[key]);
      const { data } = await updatePrivacy({
        privacySettings: payload,
      });
      dispatch(setUserData(data));
    } catch (error) {
      setValue(
        key,
        payload[key] === PrivacyType.Public
          ? PrivacyType.Private
          : PrivacyType.Public
      );
    }
  };

  return (
    <div className="flex-1 bg-white px-6 py-6 rounded-md border border-gray-200 text-xs h-fit">
      <p className="text-xs font-semibold">Profile Privacy</p>
      <div className="grid grid-cols-9 gap-1 items-center bg-[#F1F5F9] mt-5 py-1 rounded">
        <div className="flex col-span-2  h-2"></div>
        <div className="text-xs  text-center text-charcoal">About</div>
        <div className="text-xs  text-center text-charcoal">Experience</div>
        <div className="text-xs text-center text-charcoal">Skills</div>
        <div className="text-xs text-center text-charcoal col-span-2">
          Educations & Certifications
        </div>
        <div className="text-xs text-center text-charcoal col-span-2">
          Contact Details
        </div>
      </div>
      <div className="grid grid-cols-9 gap-1 items-center mt-8">
        <div className="text-xs col-span-2 text-charcoal">
          My Referral Member
        </div>
        <div className="flex  justify-center">
          <div
            role="button"
            className="flex border border-primary items-center justify-center rounded h-6 w-6 hover:bg-gray-200"
            onClick={() =>
              changePrivacy({
                about:
                  fields?.about === PrivacyType.Public
                    ? PrivacyType.Private
                    : PrivacyType.Public,
              })
            }
          >
            {fields?.about === PrivacyType.Public && (
              <Check width={20} height={20} />
            )}
          </div>
        </div>
        <div className="flex  justify-center">
          <div
            className="flex border border-primary items-center justify-center rounded h-6 w-6 hover:bg-gray-200"
            role="button"
            onClick={() =>
              changePrivacy({
                experience:
                  fields?.experience === PrivacyType.Public
                    ? PrivacyType.Private
                    : PrivacyType.Public,
              })
            }
          >
            {fields?.experience === PrivacyType.Public && (
              <Check width={20} height={20} />
            )}
          </div>
        </div>
        <div className="flex justify-center">
          <div
            className="flex border border-primary items-center justify-center rounded h-6 w-6 hover:bg-gray-200"
            role="button"
            onClick={() =>
              changePrivacy({
                skills:
                  fields?.skills === PrivacyType.Public
                    ? PrivacyType.Private
                    : PrivacyType.Public,
              })
            }
          >
            {fields?.skills === PrivacyType.Public && (
              <Check width={20} height={20} />
            )}
          </div>
        </div>
        <div className="flex justify-center col-span-2">
          <div
            className="flex border border-primary items-center justify-center rounded h-6 w-6 hover:bg-gray-200"
            role="button"
            onClick={() =>
              changePrivacy({
                education:
                  fields?.education === PrivacyType.Public
                    ? PrivacyType.Private
                    : PrivacyType.Public,
              })
            }
          >
            {fields?.education === PrivacyType.Public && (
              <Check width={20} height={20} />
            )}
          </div>
        </div>
        <div className="flex justify-center col-span-2">
          <div
            className="flex border border-primary items-center justify-center rounded h-6 w-6 hover:bg-gray-200"
            role="button"
            onClick={() =>
              changePrivacy({
                contact:
                  fields?.contact === PrivacyType.Public
                    ? PrivacyType.Private
                    : PrivacyType.Public,
              })
            }
          >
            {fields?.contact === PrivacyType.Public && (
              <Check width={20} height={20} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
